"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const CORE_VITAL_METRICS = new Set(['cls', 'fid', 'lcp', 'inp', 'fcp', 'ttfb']);
class MetricsCollector {
  constructor() {
    this._metricsCollection = new Set();
    this._latestMetrics = {};
  }
  addMetric(metric) {
    if (!this._isCoreVitalMetric(metric)) {
      return;
    }
    const trackingMetric = this._getTrackingMetric(metric);
    const latestTrackingMetric = this._getLatestTrackingMetric(metric);
    this._metricsCollection.add(trackingMetric);
    this._latestMetrics[trackingMetric.name] = latestTrackingMetric;
  }
  getAllMetrics() {
    return {
      allMetrics: [...this._metricsCollection],
      latest: _objectSpread({}, this._latestMetrics)
    };
  }
  newMetricsAvailable() {
    return this._metricsCollection.size > 0;
  }
  clear() {
    this._metricsCollection.clear();
  }
  _isCoreVitalMetric(metric) {
    return metric.name && CORE_VITAL_METRICS.has(metric.name.toLowerCase());
  }
  _getTrackingMetric(metric) {
    const {
      id,
      name,
      value,
      delta,
      navigationType
    } = metric;
    return {
      id,
      name: name.toLowerCase(),
      value,
      delta,
      navigationType
    };
  }
  _getLatestTrackingMetric(metric) {
    const {
      id,
      value,
      delta,
      navigationType
    } = metric;
    return {
      id,
      value,
      delta,
      navigationType
    };
  }
}
module.exports = MetricsCollector;